import { NgModule } from '@angular/core';
import { PasswordManagementRoutingModule } from './password-management-routing.module';
import { PasswordManagementComponent } from './password-management.component';
import {ResetPasswordViewComponent} from './views/reset-password/reset-password-view.component';
import {SetPasswordViewComponent} from './views/set-password/set-password-view.component';
import { SetPasswordSuccessViewComponent } from './views/set-password-success/set-password-success-view.component';
import { ResetPasswordSuccessViewComponent } from './views/reset-password-success/reset-password-success-view.component';
import {SharedModule} from '../shared/shared.module';
import {RouterModule} from '@angular/router';

@NgModule({
    declarations: [
        PasswordManagementComponent,
        ResetPasswordViewComponent,
        SetPasswordViewComponent,
        SetPasswordSuccessViewComponent,
        ResetPasswordSuccessViewComponent
    ],
    imports: [
        SharedModule,
        PasswordManagementRoutingModule,
        RouterModule
    ]
})
export class PasswordManagementModule { }
